import React from 'react';
import { Typography, Box, Divider } from '@mui/material';
import BlueFlow from '../../assets/images/Blue_flow.jpg';

function AboutTab() {
  return (
    <Box sx={{ padding: 2 }}>
      {/* Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          marginBottom: 2,
          color: '#000', // Black text for consistency
        }}
      >
        About
      </Typography>

      {/* Main Content */}
      <Box
        sx={{
          padding: 0,
          maxWidth: 800,
          margin: 'auto',
          borderRadius: 4,
          overflow: 'hidden', // Ensures the image wraps seamlessly
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Header Image */}
        <Box
          sx={{
            height: 200,
            backgroundImage: `url(${BlueFlow})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />

        {/* Content */}
        <Box
          sx={{
            padding: 4,
            backgroundColor: '#ffffff', // Ensures contrast with the image
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600, // Slightly thinner than bold (700)
              marginBottom: 3,
              color: '#000', // Black text
            }}
          >
            About the Faculty Grant Matching System
          </Typography>

          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.8,
              fontSize: '1.1rem',
              color: '#000', // Black text
              marginBottom: 2,
            }}
          >
            The Faculty Grant Matching System is designed to help faculty members identify the most
            relevant grant opportunities based on their research interests and publications. By
            combining matching algorithms and Artificial Intelligence, the system simplifies and
            accelerates the process of finding appropriate grants.
          </Typography>

          <Divider sx={{ marginY: 3 }} />

          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.8,
              fontSize: '1.1rem',
              color: '#000', // Black text
            }}
          >
            Use the sidebar to explore the application features, such as viewing top grants,
            creating a portfolio, chatting with the Grant AI, and accessing helpful resources.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default AboutTab;
